
document.addEventListener("DOMContentLoaded", function () {
  console.log("NeonCloud script loaded");

  const container = document.getElementById("neoncloud-customizer");
  if (!container) {
    console.error("NeonCloud container not found.");
    return;
  }

  const room = window["neoncloud-customizer-data"]?.rooms?.[0];
  if (!room) {
    console.error("No room image found.");
    return;
  }

  container.classList.add("neoncloud-wrapper");
  container.style.backgroundImage = `url(${room.image})`;

  const neonText = document.createElement("div");
  neonText.classList.add("neoncloud-text");
  neonText.textContent = "NeonCloud";

  const input = document.createElement("input");
  input.type = "text";
  input.placeholder = "Type your sign text...";
  input.className = "neoncloud-input";
  input.addEventListener("input", () => {
    neonText.textContent = input.value;
  });

  const slider = document.createElement("input");
  slider.type = "range";
  slider.min = "20";
  slider.max = "100";
  slider.value = "48";
  slider.className = "neoncloud-slider";
  slider.addEventListener("input", () => {
    neonText.style.fontSize = `${slider.value}px`;
  });

  const colorPicker = document.createElement("input");
  colorPicker.type = "color";
  colorPicker.className = "neoncloud-color";
  colorPicker.value = "#ff00cc";
  colorPicker.addEventListener("input", () => {
    neonText.style.color = colorPicker.value;
    neonText.style.textShadow = `0 0 5px ${colorPicker.value}, 0 0 10px ${colorPicker.value}, 0 0 20px ${colorPicker.value}`;
  });

  const fontSelect = document.createElement("select");
  fontSelect.className = "neoncloud-font";
  ["Arial", "Cursive", "Monospace", "Fantasy", "Sans-serif"].forEach(font => {
    const option = document.createElement("option");
    option.value = font;
    option.textContent = font;
    fontSelect.appendChild(option);
  });
  fontSelect.addEventListener("change", () => {
    neonText.style.fontFamily = fontSelect.value;
  });

  const downloadBtn = document.createElement("button");
  downloadBtn.textContent = "Download Preview";
  downloadBtn.className = "neoncloud-download";
  downloadBtn.addEventListener("click", () => {
    html2canvas(container).then((canvas) => {
      const link = document.createElement("a");
      link.download = "neon_preview.png";
      link.href = canvas.toDataURL();
      link.click();
    });
  });

  container.appendChild(neonText);
  container.appendChild(input);
  container.appendChild(slider);
  container.appendChild(colorPicker);
  container.appendChild(fontSelect);
  container.appendChild(downloadBtn);

  const updateCartNote = () => {
    const noteContent = `Custom Neon Quote:\nText: ${neonText.textContent}\nFont: ${fontSelect.value}\nColor: ${colorPicker.value}\nSize: ${slider.value}px`;
    const noteField = document.querySelector("textarea[name='note']");
    if (noteField) {
      noteField.value = noteContent;
    }
  };

  [input, slider, colorPicker, fontSelect].forEach(el => {
    el.addEventListener("input", updateCartNote);
  });

  let offsetX, offsetY, isDragging = false;

  const startDrag = (e) => {
    isDragging = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    offsetX = clientX - neonText.offsetLeft;
    offsetY = clientY - neonText.offsetTop;
  };

  const endDrag = () => { isDragging = false; };

  const drag = (e) => {
    if (isDragging) {
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      neonText.style.left = `${clientX - offsetX}px`;
      neonText.style.top = `${clientY - offsetY}px`;
    }
  };

  neonText.addEventListener("mousedown", startDrag);
  neonText.addEventListener("touchstart", startDrag);
  document.addEventListener("mouseup", endDrag);
  document.addEventListener("touchend", endDrag);
  document.addEventListener("mousemove", drag);
  document.addEventListener("touchmove", drag);
});
